export default {"src":"/_next/static/media/image-refuse.8c62ef9b.svg","height":165,"width":147};